import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ResourceUsages} from "../resources/types";
import {RESOURCE_USAGES_QUERY_KEY} from "../queryKeys";

type Variables = {id: number};

const getAssetUsages = async (variables: Variables): Promise<ResourceUsages> => {
  const response = await axiosReachInstance.get<ResourceUsages, AxiosResponse<ResourceUsages>>(
    `/assets/${variables.id}/usages`
  );
  return response.data;
};

export const useGetAssetUsages = (
  variables: Variables,
  options?: BaseQueryOptions<ResourceUsages, Variables>
): BaseUseQueryResult<ResourceUsages> => {
  return useBaseQuery<ResourceUsages, Variables>(
    [RESOURCE_USAGES_QUERY_KEY, "asset", variables.id],
    getAssetUsages,
    variables,
    {refetchOnMount: "always", ...options}
  );
};
